import { render, staticRenderFns } from "./SSDashboardStaffListRow.vue?vue&type=template&id=98e93a96&scoped=true&"
import script from "./SSDashboardStaffListRow.vue?vue&type=script&lang=js&"
export * from "./SSDashboardStaffListRow.vue?vue&type=script&lang=js&"
import style0 from "./SSDashboardStaffListRow.vue?vue&type=style&index=0&id=98e93a96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e93a96",
  null
  
)

export default component.exports